var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStep6(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A82939;}\n\t.st1{fill:none;stroke:#75232E;stroke-width:5;}\n\t.st2{fill:#A21B2C;}\n\t.st3{fill:none;stroke:#75232E;stroke-width:4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.5,39.2c4,0,6.1,2.7,6.1,7.4c0,4.8-2.5,7.7-5.8,7.7c-4,0-6.6-3.4-7.2-10.8C35.8,40.3,38.3,39.2,40.5,39.2z  M40.8,58.7c6,0,11-4.8,11-12.1c0-7.8-4.1-11.6-10.3-11.6c-2.7,0-5.8,1.6-8,4.2c0.2-10.5,4.2-14.1,8.8-14.1c2.2,0,4.4,1.2,5.8,2.8 l3.2-3.5c-2.1-2.2-5.1-3.9-9.2-3.9c-7.2,0-13.9,5.7-13.9,19.8C28.2,52.8,33.8,58.7,40.8,58.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 40,
    cy: 40,
    r: 37.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep6);
export default __webpack_public_path__ + "static/media/step6.3346d362.svg";
export { ForwardRef as ReactComponent };